module.exports = __webpack_public_path__ + "static/404-78c1714d66065077697e0e3239a8139a.gif";